var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "li",
    {
      staticClass: "courseware-structural-element-selector-item",
    },
    [
      _c(
        "span",
        {
          ref: "radiobutton-" + _vm.element.id,
          staticClass: "radiobutton",
          attrs: {
            tabindex: _vm.tabindex,
            role: "radio",
            "aria-checked": _vm.selected ? "true" : "false",
            "aria-labelledby": _vm.labelId,
          },
          on: {
            click: function click($event) {
              return _vm.handleClickInput(_vm.element.id)
            },
            keydown: function keydown($event) {
              return _vm.handleKeyInput($event, _vm.element.id)
            },
          },
        },
        [
          _vm.selectable
            ? [
                _vm.selected
                  ? _c("studip-icon", {
                      attrs: {
                        shape: "radiobutton-checked",
                      },
                    })
                  : _c("studip-icon", {
                      attrs: {
                        shape: "radiobutton-unchecked",
                      },
                    }),
              ]
            : _c("studip-icon", {
                attrs: {
                  shape: "decline",
                  role: "inactive",
                },
              }),
        ],
        2
      ),
      _vm._v(" "),
      _vm.hasChildren
        ? [
            _c(
              "a",
              {
                attrs: {
                  href: "#",
                  "aria-expanded": _vm.isOpen ? "true" : "false",
                },
                on: {
                  click: function click($event) {
                    $event.preventDefault()
                    return _vm.toggleChildrenVisibility.apply(null, arguments)
                  },
                },
              },
              [
                !_vm.isOpen
                  ? _c("studip-icon", {
                      attrs: {
                        shape: "arr_1right",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isOpen
                  ? _c("studip-icon", {
                      attrs: {
                        shape: "arr_1down",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    attrs: {
                      id: _vm.labelId,
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.element.attributes.title) +
                        "\n                "
                    ),
                    !_vm.selectable
                      ? _c(
                          "span",
                          {
                            staticClass: "sr-only",
                          },
                          [_vm._v(_vm._s(_vm.$gettext("nicht wählbar")))]
                        )
                      : _vm._e(),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.isOpen
              ? _c(
                  "ul",
                  _vm._l(_vm.children, function (child) {
                    return _c("courseware-structural-element-selector-item", {
                      key: child.id,
                      attrs: {
                        element: child,
                        siblings: _vm.children,
                        selectedId: _vm.selectedId,
                        focusedElementId: _vm.focusedElementId,
                        rootId: _vm.rootId,
                        validateAncestors: _vm.validateAncestors,
                        targetId: _vm.targetId,
                        targetAncestors: _vm.targetAncestors,
                        selectablePurposes: _vm.selectablePurposes,
                      },
                      on: {
                        input: _vm.handleInput,
                        focus: _vm.handleFocus,
                        selectable: _vm.updateSelectable,
                      },
                    })
                  }),
                  1
                )
              : _vm._e(),
          ]
        : [
            _c("studip-icon", {
              staticClass: "inactive",
              attrs: {
                shape: "arr_1right",
                role: "inactive",
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                attrs: {
                  id: _vm.labelId,
                },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.element.attributes.title) +
                    "\n            "
                ),
                !_vm.selectable
                  ? _c(
                      "span",
                      {
                        staticClass: "sr-only",
                      },
                      [_vm._v(_vm._s(_vm.$gettext("nicht wählbar")))]
                    )
                  : _vm._e(),
              ]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }